import React from 'react'

import { cn } from '~/styled'

import { Tile } from '../tile/Tile'

const buildConicGradient = () => {
  const numberOfSegments = 5
  const gap = 4
  const segmentAngle = (360 - numberOfSegments * gap) / numberOfSegments
  const stops: string[] = []
  let current = 0

  Array.from({ length: numberOfSegments }).forEach(() => {
    stops.push(
      `var(--color-grey-300) ${current}deg ${current + segmentAngle}deg`
    )
    current += segmentAngle
    stops.push(`white ${current}deg ${current + gap}deg`)
    current += gap
  })

  return `conic-gradient(${stops.join(', ')})`
}

export const SkeletonDoughnutChart = ({
  className
}: {
  className?: string
}) => (
  <Tile className={cn('p-6', 'size-60', className)}>
    <div
      className="animate-shimmer aspect-square w-full rounded-full [background-image:var(--gradient)] bg-clip-padding"
      style={{ '--gradient': buildConicGradient() }}
    >
      <div className="mt-[20%] ml-[20%] size-[60%] rounded-full bg-white" />
    </div>
  </Tile>
)
